import React from "react";
import Modal from "@mui/material/Modal";
import CircularProgress from "@mui/material/CircularProgress";

const ModalComponent = ({
  text,
  openState,
  closeFunction,
  btnText1,
  btnClickFunc1,
  btnText2,
  btnClickFunc2,
  loader,
}) => {
  return (
    <Modal
      open={openState}
      onClose={closeFunction}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      BackdropProps={{ style: { backgroundColor: "rgba(120,118,161,0.5)" } }}
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <div className="w-11/12 max-w-md bg-white rounded-xl p-6 shadow-2xl outline-none">
        <div className="flex flex-col gap-4">
          <h3 className="text-lg font-semibold text-[#211F59] text-center">{btnText1 || "Notice"}</h3>
          <p id="modal-modal-description" className="text-sm text-[#61607a] text-center">{text}</p>

          {loader && (
            <div className="flex justify-center py-2">
              <CircularProgress color="secondary" />
            </div>
          )}

          <div className="flex items-center justify-center gap-3 mt-2">
            {btnText2 && (
              <button
                onClick={btnClickFunc2}
                className="px-4 py-2 rounded-lg border border-[#7876A1] text-[#7876A1] font-semibold bg-transparent"
              >
                {btnText2}
              </button>
            )}

            {btnText1 && (
              <button
                onClick={btnClickFunc1}
                disabled={loader}
                className={`px-4 py-2 rounded-lg text-white font-semibold shadow ${loader ? 'bg-slate-500 cursor-not-allowed' : 'bg-[var(--primary)]'}`}
              >
                {loader ? (
                  <div className="flex items-center gap-2">
                    <CircularProgress size={18} color="inherit" />
                    <span>Requesting...</span>
                  </div>
                ) : (
                  btnText1
                )}
              </button>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalComponent;
